import {Component, OnInit} from '@angular/core';
import {StoreListService} from '~/app/core/common/services/store-list.service';
import {Store} from '~/app/core/common/models/store';
import {DialogHelperComponent} from '~/app/shared/helpers/dialog-helper';
import {MogService} from '~/app/core/common/services/mog.service';
import {LoadingIndicatorHelper} from '~/app/shared/helpers/loading-indicator-helper';
import {DialogService} from '@progress/kendo-angular-dialog';

@Component({
    selector: 'app-mog',
    templateUrl: './mog.component.html',
    styleUrls: ['./mog.component.scss']
})
export class MogComponent implements OnInit {

    public storeListContainer: Store[] = [];
    public storesToAdd: Store[] = [];
    public storesToDelete: Store[] = [];
    public grpMap = new Map<number, string>();
    public groupMap = new Map<string, Array<Store>>();
    grpNo: { caption: string; storeList: any[]; groupId: string; selected: boolean };
    map = new Map<number, String>();
    public NEWGROUP = 'newgroup';
    groupList = [
        {groupId: this.NEWGROUP, caption: 'New Group', storeList: [], selected: false},
        // {groupId: 1, caption: 'Group 1', storeList: [], selected: false}
    ];
    NAME = 'Master Order Guide';
    newGroupMessage = 'You can move only one store to a new group. '
        + '(Note: When creating a new group you must designate only '
        + 'one store to start the group.  Other stores added to the '
        + 'group will inherit this store\'s item customization settings)';
    mMessage = 'Please select at least one store and one group to add store to a group.';
    public storeList: Store[];
    public storesSelected = 0;
    item: any;
    showDeleteButton = false;
    public result;

    constructor(public storeListService: StoreListService,
                public mogService: MogService,
                public loadingIndicatorHelper: LoadingIndicatorHelper,
                public dialogService: DialogService,
                public dialogHelperComponent: DialogHelperComponent) {
    }

    async ngOnInit() {
        this.loadingIndicatorHelper.show('');
        this.storeList = this.storeListService.storeList;
        await this.loadData();
        this.loadingIndicatorHelper.hide();
    }

    async loadData() {
        this.showDeleteButton = false;
        this.storeList = await this.storeListService.getAllStores();
        this.storeListContainer = [];
        this.groupList = [
            {groupId: this.NEWGROUP, caption: 'New Group', storeList: [], selected: false},
        ];
        this.grpMap.clear();
        this.groupMap.clear();

        this.storeList.forEach(store => {
            if (store.groupId === 0) {
                this.storeListContainer.push(store);
            } else {
                if (!this.grpMap.has(store.groupId)) {
                    const itemId = this.groupList.length;
                    const newItem = {
                        groupId: store.groupId.toString(),
                        caption: 'Group ' + itemId,
                        storeList: [],
                        selected: false
                    };
                    this.groupList.push(newItem);
                    this.grpMap.set(store.groupId, 'Group ' + itemId);
                    this.groupMap.set('Group ' + itemId, new Array<Store>());
                }
                this.groupMap.get(this.grpMap.get(store.groupId)).push(store);
                if (this.groupMap.size > 0) {
                    this.showDeleteButton = true;
                }
            }
        });
    }

    toggleStoreSelection(store: Store) {
        store.selected = !store.selected;
    }

    toggleGroupSelection(group: { caption: string; storeList: any[]; groupId: string; selected: boolean }) {
        this.groupList.forEach(g => {
            g.selected = false;
        });
        group.selected = !group.selected;
        this.grpNo = group;
    }

    toggleGroupStoreSelection(store: Store) {
        const index = this.storesToDelete.indexOf(store);
        store.selected = !store.selected;
        if (store.selected) {
            this.storesToDelete.push(store);
        } else {
            this.storesToDelete.splice(index, 1);
        }
    }

    public async addStoresToGroup() {
        this.loadingIndicatorHelper.show('');
        this.storesSelected = 0;
        this.storesToAdd = [];
        this.storeListContainer.forEach(store => {
            if (store.selected) {
                this.storesSelected++;
                this.storesToAdd.push(store);
            }
        });
        if (this.storesSelected > 0 && this.grpNo !== undefined && this.grpNo.selected !== false) {
            if (this.grpNo.groupId === this.NEWGROUP && this.storesSelected > 1) {
                this.dialogHelperComponent.showConfirmDialogOkOnly(this.NAME, this.newGroupMessage).then(r => r);
            } else {
                this.showDeleteButton = true;
                await this.mogService.update(this.grpNo.groupId, this.storesToAdd).then(result => {
                    this.loadData().then(r => r);
                });
                this.grpNo.selected = false;
                this.storeListContainer.forEach(store => {
                    store.selected = false;
                });
            }
        } else {
            this.dialogHelperComponent.showConfirmDialogOkOnly(this.NAME, this.mMessage).then(r => r);
        }
        this.loadingIndicatorHelper.hide();
    }

    async deleteBtnClicked() {
        this.loadingIndicatorHelper.show('');
        if (this.storesToDelete.length > 0) {
            await this.mogService.update(null, this.storesToDelete)
                .then(result => {
                    this.loadData().then(r => r);
                });
            this.storesToDelete = [];
        } else {
            this.dialogHelperComponent.showConfirmDialogOkOnly('Delete', 'You must select a store to be deleted.').then(r => r);
        }
        this.loadingIndicatorHelper.hide();
    }
}
